// Kapsayıcı genişliğini ResizeObserver ile ölçer (react-grid-layout `width` prop'u için).
import { useCallback, useState } from 'react';

export function useElementWidth(): { width: number; ref: (el: HTMLElement | null) => void } {
  const [width, setWidth] = useState(0);
  // Ölçüm ref geri çağrısında başlar; render sırasında ref okunmaz (React Compiler kuralı)
  const ref = useCallback((el: HTMLElement | null) => {
    if (!el) return;
    setWidth(el.clientWidth);
    // ResizeObserver her ortamda yok (test ortamı, eski Safari). İlk ölçüm zaten yapıldı;
    // gözlemci kurulamazsa bileşen o genişlikle çalışmaya devam eder, çökmez.
    if (typeof ResizeObserver === 'undefined') return;
    const ro = new ResizeObserver((entries) => {
      const w = entries[0]?.contentRect.width ?? el.clientWidth;
      setWidth(Math.round(w));
    });
    ro.observe(el);
    return () => ro.disconnect();
  }, []);
  return { width, ref };
}
